<template>
  <div>
    <div class="animated fadeIn">
      <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true" />
    </div>
    <b-row>
      <b-col sm="6" lg="3">
        <b-card no-body class="bg-primary">
          <b-card-body class="pb-0">
            <b-button
              class="float-right"
              variant="transparent p-0"
              right
              no-caret
              id="pushs-ativos"
            >
              <i class="fa fa-info-circle fa-lg tamanhoIcon"></i>
            </b-button>
            <h4 class="mb-0">{{ cuponsAtivos }}</h4>
            <p>Cupons ativos</p>
          </b-card-body>
        </b-card>
      </b-col>
      <b-col sm="6" lg="3">
        <b-card no-body class="bg-info">
          <b-card-body class="pb-0">
            <h4 class="mb-0">{{ cuponsUtilizados }}</h4>
            <p>Cupons utilizados</p>
          </b-card-body>
        </b-card>
      </b-col>
      <b-col sm="6" lg="3">
        <b-card no-body class="bg-success">
          <b-card-body class="pb-0">
            <h4 class="mb-0">{{ cuponsExpirados }}</h4>
            <p>Cupons expirados</p>
          </b-card-body>
        </b-card>
      </b-col>
      <b-col sm="6" lg="3">
        <b-card no-body class="bg-danger">
          <b-card-body class="pb-0">
            <b-button
              class="float-right"
              variant="transparent p-0"
              right
              no-caret
              id="pushs-visualizados"
            >
              <i class="fa fa-info-circle fa-lg"></i>
            </b-button>
            <h4 class="mb-0">{{ descontoTotal }}</h4>
            <p>Desconto total</p>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
    <b-row class="mt-3">
      <b-col cols="12">
        <b-card>
          <b-row>
            <b-col xl="6" lg="6" md="6" sm="12">
              <nav>
                <b-pagination
                  :total-rows="getRowCount(items)"
                  :per-page="perPage"
                  v-model="currentPage"
                  prev-text="Anterior"
                  next-text="Próxima"
                />
              </nav>
            </b-col>
            <b-col xl="6" lg="6" md="6" sm="12">
              <b-button
                variant="success"
                class="botaoCadastrarCupom"
                @click="redirect"
              >Cadastrar novo cupom</b-button>
            </b-col>
          </b-row>
          <b-table
            v-if="items.length > 0"
            :items="items"
            :fields="fields"
            bordered
            striped
            hover
            :current-page="currentPage"
            :per-page="perPage"
          ></b-table>
          <div v-else>
            <i class="fa fa-frown-o fa-custom-size"></i>
            <h4>Desculpe, não encontramos nenhum cupom :(</h4>
            <h5>Para iniciar, clique no botão acima e comece os cadastros!</h5>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";

import axios from "axios";
import * as config from "@/config.json";

export default {
  name: "Cupons",
  components: {
    Loading
  },
  data: function() {
    return {
      isLoading: false,
      temPromocoes: false,
      numCampanhas: 0,
      titulo: "",
      descricao: "",
      items: [],
      fields: [
        { key: "titulo", label: "Titulo" },
        { key: "descricao", label: "Descrição" },
        { key: "datahoracadastro", label: "Data de criação" },
        { key: "qtdclientesselecionados", label: "Clientes selecionados" }
      ],
      currentPage: 1,
      perPage: 5,
      totalRows: 0,
      cuponsExpirados: 0,
      descontoTotal: 0,
      cuponsUtilizados: 0,
      cuponsAtivos: 0,
      pacoteAdicional: 0,
      modalShow: false
    };
  },
  methods: {
    getRowCount(items) {
      return items.length;
    },
    userLink(cpf) {
      // return `cliente/${cpf.toString()}`;
    },
    rowClicked(item) {
      // const userLink = this.userLink(item.cpf);
      // this.$router.push({ path: userLink });
    },
    redirect() {
      localStorage.setItem("tipoid", 5);
      this.$router.push({ path: `/cadastrar-cupom` });
    }
  },
  beforeMount() {
    this.isLoading = true;
    axios
      .get(
        `${
          config.default.servidor
        }/gerencial/totalizadores-cupom/${localStorage.getItem(
          "enterprise_id"
        )}`,
        {
          headers: {
            Authorization: "Basic c2E6QURNQUNDRVNZUw=="
          }
        }
      )
      .then(response => {
        if(response.status == 200){
          this.cuponsAtivos = response.data.ativos;
          this.cuponsUtilizados = response.data.utilizados;
          this.cuponsExpirados = response.data.expirados;
        }
      });

    axios
      .get(
        `${config.default.servidor}/gerencial/cupom/${localStorage.getItem(
          "enterprise_id"
        )}`,
        {
          headers: {
            Authorization: "Basic c2E6QURNQUNDRVNZUw=="
          }
        }
      )
      .then(response => {
        this.items = response.data.data;
        for (let i = 0; i < response.data.data.length; i++) {
          const e = response.data.data[i];

        }
      });
    this.isLoading = false;
  }
};
</script>
